export class RestoreDocumentDBRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "destination",
            "baseName": "destination",
            "type": "DocumentDBRestoreDestination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreDocumentDBRequest.attributeTypeMap;
    }
    constructor() {
    }
}
